import type { MetaInfo } from 'vue-meta';

/**
 *
 * @description Method for dynamic meta tags setting.
 * By default application has noindex, nofollow in the baseConfig,
 * Here we have an ability to override this behavior
 */
export const getMetaInfo = (page: any, isNoIndex = true): MetaInfo => {
  if (!page) {
    return null;
  }

  const seoTags: MetaInfo = {
    meta: [],
  };

  if (page?.meta_title || page?.title || page?.name) {
    seoTags.title = page?.meta_title || page?.title || page?.name;
  }
  if (page?.meta_description) {
    seoTags.meta.push({
      hid: 'description',
      name: 'description',
      content: page.meta_description,
    });
  }
  if (page?.meta_keyword || page?.meta_keywords) {
    seoTags.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: page?.meta_keyword || page?.meta_keywords,
    });
  }

  seoTags.meta.push({
    hid: 'robots',
    name: 'robots',
    content: isNoIndex ? 'noindex, nofollow' : 'index, follow',
  });

  return seoTags;
};
